module.exports = __webpack_public_path__ + "img/sliders-alt-horizontal.fab2c0ce.svg";